import { showMessage } from '../actions/show-message';

export default store => (...args) => store.dispatch(showMessage(...args));



// WEBPACK FOOTER //
// ./app/services/create-show-message.js